// LIBRARY
import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Table as AntTable, Spin as AntSpin } from 'antd';
import { GLOBAL_TABLE_SIZE } from 'global_config/constant-global';

// CSS
import './phlebo_result_table.css';
import moment from 'moment';

class SearchPatientTable extends React.Component {
	/**
	 * @param {{ dateCreated: any; addressID: any; }} record
	 */
	handleDoubleClick = record => {
		// eslint-disable-next-line react/prop-types
		const { drawer } = this.props;
		drawer(record);
	};

	handlePaginationChange = (page, pageSize) => {
		const { onPageChange } = this.props;
		if (onPageChange) {
			onPageChange(page);
		}
	};

	render() {
		const { data, pageSize, loading, currentPage } = this.props;

		const getSorter = (myDataSource, columnName) => {
			// @ts-ignore
			if (myDataSource === undefined || myDataSource.length === 0) {
				return false;
			}

			if (myDataSource.length > 0) {
				const columnSorter = (a, b) => {
					if (a[columnName] !== null) {
						return a[columnName].localeCompare(b[columnName]);
					}
					return 0;
				};

				return columnSorter;
			}
			return false;
		};

		// CONSTANTS
		const columns = [
			{
				title: 'REQUEST ID',
				dataIndex: 'requestID',
				sorter: getSorter(data, 'requestID'),
				width: 100,
				fixed: 'left',
			},
			{
				title: 'REQUEST DATE',
				dataIndex: 'requestDateTime',
				width: 120,
				render: requestDateTime => {
					return <text>{moment(requestDateTime).format('MM-DD-YYYY hh:mm A')}</text>;
				},
				fixed: 'left',
			},
			{
				title: 'PATIENT ID',
				dataIndex: 'patientID',
				sorter: getSorter(data, 'patientID'),
				width: 100,
				fixed: 'left',
			},
			{
				title: 'LAST NAME',
				dataIndex: 'lastName',
				sorter: getSorter(data, 'lastName'),
				width: 150,
			},
			{
				title: 'FIRST NAME',
				dataIndex: 'givenName',
				sorter: getSorter(data, 'givenName'),
				width: 150,
			},
			{
				title: 'MIDDLE NAME',
				dataIndex: 'middleName',
				sorter: getSorter(data, 'middleName'),
				width: 150,
			},
			{
				title: 'BIRTHDATE',
				dataIndex: 'dateOfBirth',
				sorter: getSorter(data, 'dateOfBirth'),
				width: 100,
			},
			{
				title: 'GENDER',
				dataIndex: 'sex',
				sorter: getSorter(data, 'sex'),
				width: 80,
			},
			{
				title: 'ADDRESS',
				dataIndex: 'address',
				sorter: getSorter(data, 'address'),
				render: (text, row) => {
					const { address, townName, cityMunicipalityName, provinceName } = row;

					if (row.address)
						return `${address}, ${townName}, ${cityMunicipalityName}, ${provinceName}`.toUpperCase();

					return '';
				},
				width: 400,
			},
		];

		return (
			<AntSpin spinning={loading} tip="Loading...">
				<div>
					<AntTable
						className="phlebo-result-table"
						pagination={{
							pageSize,
							showSizeChanger: false,
							current: currentPage,
							onChange: this.handlePaginationChange
						}}
						size={GLOBAL_TABLE_SIZE}
						// @ts-ignore
						columns={columns}
						dataSource={data}
						scroll={{ x: 1500 }}
						// scroll={{ y: 'calc(100vh - 500px)' }}
						rowKey={record => record.requestID}
						onRow={record => {
							return {
								onDoubleClick: () => {
									// @ts-ignore
									this.handleDoubleClick(record);
								},
							};
						}}
					/>
				</div>
			</AntSpin>
		);
	}
}

SearchPatientTable.propTypes = {
	data: PropTypes.arrayOf(
		PropTypes.shape({
			givenName: PropTypes.string.isRequired,
			lastName: PropTypes.string.isRequired,
			middleName: PropTypes.string.isRequired,
			dateOfBirth: PropTypes.string.isRequired,
			sex: PropTypes.string.isRequired,
		}),
	).isRequired,
	pageSize: PropTypes.number.isRequired,
	loading: PropTypes.bool.isRequired,
	onPageChange: PropTypes.func,
	currentPage: PropTypes.number,
};

export default withRouter(SearchPatientTable);
